import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import FinancialReportsGenerator from './pages/financial-reports-generator';
import ClientManagementSystem from './pages/client-management-system';
import FinancialDashboardOverview from './pages/financial-dashboard-overview';
import ExpenseManagementSystem from './pages/expense-management-system';
import AuthenticationAndRoleSelection from './pages/authentication-and-role-selection';
import UserProfile from './pages/user-profile';
import Settings from './pages/settings';
import NegotiationsManagementHub from 'pages/negotiations-management-hub';
import EnhancedClientManagementWithPassengers from 'pages/enhanced-client-management-with-passengers';
import AuthCallback from 'pages/auth-callback';
import PaymentHistoryAndTimelineTracking from './pages/payment-history-and-timeline-tracking';
import SupplierManagementSystem from "./pages/supplier-management-system";
import SupplierRegistrationAndManagement from "./pages/supplier-registration-and-management";
import ComprehensiveAuditTrail from "./pages/comprehensive-audit-trail-and-activity-logs";
import RealTimeSystemPerformanceMonitoringDashboard from "./pages/real-time-system-performance-monitoring-dashboard";
import CashFlowManagementDashboard from "./pages/cash-flow-management-dashboard";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AuthenticationAndRoleSelection />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/financial-reports-generator" element={<FinancialReportsGenerator />} />
          <Route path="/client-management-system" element={<ClientManagementSystem />} />
          <Route path="/financial-dashboard-overview" element={<FinancialDashboardOverview />} />
          <Route path="/negotiations-management-hub" element={<NegotiationsManagementHub />} />
          <Route path="/enhanced-client-management-with-passengers" element={<EnhancedClientManagementWithPassengers />} />
          <Route path="/expense-management-system" element={<ExpenseManagementSystem />} />
          <Route path="/authentication-and-role-selection" element={<AuthenticationAndRoleSelection />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/payment-history-and-timeline-tracking" element={<PaymentHistoryAndTimelineTracking />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/supplier-management-system" element={<SupplierManagementSystem />} />
          <Route path="/supplier-registration-and-management" element={<SupplierRegistrationAndManagement />} />
          <Route path="/comprehensive-audit-trail-and-activity-logs" element={<ComprehensiveAuditTrail />} />
          <Route path="/real-time-system-performance-monitoring-dashboard" element={<RealTimeSystemPerformanceMonitoringDashboard />} />
          <Route path="/cash-flow-management-dashboard" element={<CashFlowManagementDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}